export const getMunicipios = (state) => state.municipios.lista
export const getIsCarregandoListaMunicipios = (state) => state.municipios.isCarregandoLista
